import useStore from 'components/sharedCode/stores/store';
import { openNewGroupFromFolder, updateSingleTab } from '../browserAPI';
import layoutStore from 'components/sharedCode/stores/layoutStore';
import usePersistStore from 'components/sharedCode/stores/persistStore';
import { changeWorkspaceFront } from '../platformMessages';
import { getAllWSData } from 'util/db';

export const bookmarkFilter = (set, get) => {};
export const queryTabs = (set, get) => {};

export const getRecent = (set, get) => {};

export const getAllWorkspaces = (set, get) => {
    getAllWSData().then((resp: any) => {
        if (resp.msg === 'success') {
            let allTabs = resp.allWSdata.flatMap((workspace) => {
                if (Array.isArray(workspace.tabData)) {
                    return workspace.tabData.flatMap((tabData) =>
                        Array.isArray(tabData.tabs) ? tabData.tabs : []
                    );
                } else {
                    return [];
                }
            });
            set({
                currentSearchData: {
                    ...get().currentSearchData,
                    all: allTabs
                },
                allWSdata: resp.allWSdata
            });
        } else {
            //Add toast
            let setShowToast = useStore.getState().setShowToast;
            setShowToast(
                'Something went wrong',
                'Could not fetch all workspaces data',
                'error'
            );
        }
    });
};
export const handleEnterAction = (set, get) => {
    set({ loadingCurrentSite: true });
    let item = get().itemsToShow[get().selectedIndex];
    const typeOfItem = item.url
        ? item.comment?.length
            ? 'tabWithNote'
            : 'tab'
        : item.isStacked
        ? 'stack'
        : 'note';
    if (get().currentFilter === 'active') {
        //let w = window.screen.height;
        //let h = window.screen.width;
    } else {
        if (
            typeOfItem === 'stack' &&
            get().currentFilter !== 'current' &&
            get().currentFilter !== 'all'
        ) {
            let group = {
                title: item.title ? item.title : '',
                tabs: [...item.stackedItems]
            };
            openNewGroupFromFolder(group);
        } else if (
            typeOfItem === 'note' ||
            get().currentFilter === 'current' ||
            get().currentFilter === 'all'
        ) {
            let setShowSearchModal = layoutStore.getState().setShowSearchModal;
            if (get().currentFilter === 'current') {
                console.log('current');
                //Find the category Index ->
                let tabGroups = useStore.getState().tabGroups;
                let categories = useStore.getState().categories;
                let info = tabGroups.find((group) =>
                    group?.tabs?.some((sum) => sum.id === item.id)
                );
                let inCategoryIndex = categories.findIndex(
                    (cat) => cat.id === info.categoryID
                );
                let setSelectedCategory =
                    usePersistStore.getState().setSelectedCategory;
                let setGroupsToShow = useStore.getState().setGroupsToShow;
                //If found, we go to the category and close the search modal
                if (inCategoryIndex !== -1) {
                    setSelectedCategory(inCategoryIndex);
                    setGroupsToShow(inCategoryIndex);
                    setShowSearchModal(false);
                }
                return;
            } else {
                let allWSdata = get().allWSdata;
                let allWsGroups = allWSdata.flatMap((workspace) => {
                    return workspace && Array.isArray(workspace.tabData)
                        ? workspace.tabData
                        : [];
                });
                let info = allWsGroups.find((group) =>
                    group?.tabs?.some((sum) => sum.id === item.id)
                );
                let inWS = allWSdata.find((group) =>
                    group.tabData.some((item) => item.id === info.id)
                );
                let inCategoryIndex = inWS.categories.findIndex(
                    (cat) => cat.id === info.categoryID
                );
                const loadingMock = () => {};
                if (inWS.WSid && inCategoryIndex) {
                    changeWorkspaceFront(
                        loadingMock,
                        inWS.WSid,
                        inCategoryIndex
                    );
                    setShowSearchModal(false);
                }
                return;
            }
            //Find the item and go to it
        } else {
            updateSingleTab(item.url);
            return;
        }
        updateSingleTab(item.url);
    }
};
